import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/lib/i18n";

const LanguageContext = createContext({
  lang: "es",
  toggleLang: () => {},
  setLang: () => {},
  t: (k) => k,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "es";
    const saved = localStorage.getItem("kd9-lang");
    return saved === "en" ? "en" : "es";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.classList.add("notranslate");
    document.documentElement.setAttribute("translate", "no");
    localStorage.setItem("kd9-lang", lang);
  }, [lang]);

  const setLang = useCallback((l) => {
    if (l === "es" || l === "en") setLangState(l);
  }, []);
  const toggleLang = useCallback(
    () => setLangState((l) => (l === "es" ? "en" : "es")),
    [],
  );

  useEffect(() => {
    const syncLanguage = (event) => {
      if (event.key === "kd9-lang" && (event.newValue === "es" || event.newValue === "en")) {
        setLangState(event.newValue);
      }
    };
    window.addEventListener("storage", syncLanguage);
    return () => window.removeEventListener("storage", syncLanguage);
  }, []);

  const t = useCallback(
    (key) => {
      const dict = translations[lang] || translations.es;
      return dict[key] ?? translations.es[key] ?? key;
    },
    [lang],
  );

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
